let TEXT_FALLBACK = '?';

function hashCode(s: string) {
  const str = String(s);
  let hash = 0;
  let char;

  if (str.trim().length === 0) return hash;

  for (let i = 0; i < str.length; i++) {
    char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash; // Convert to 32bit integer
  }

  return Math.abs(hash);
}

export function getKeyFromText<T>(
  keys: readonly T[],
  text: string = TEXT_FALLBACK
): T {
  const hash = hashCode(text);
  const key = keys[hash % (keys.length + 1)];
  return key;
}
